module.exports = __webpack_public_path__ + "img/dots_mbp3.e08a952b.png";